import * as views from './pages'

angular.module('app.cessao').config(function ($stateProvider, lazyLoadProvider) {
    $stateProvider
        .state('app.cessao', {
            abstract: true
        })
        .state('app.cessao.integracaoporcallbackenvio', {
            url: '/bos/registradora/cessaoporcallback/enviocessao',
            views: {
                'content@app': lazyLoadProvider.create(views.integracaoCessaoPorCallbackEnvio)
            },
            data: {
                title: 'Consulta Integração',
                access: { requiredPermissions: ['RemessaFundo', 'backoffice'] },
                breadcrumbs: ['BOS', 'Cessão por Callback', 'Consulta Integração']
            }
        })
        .state('app.cessao.cessaohub', {
            url: '/bos/cessaohub?codigo&passo',
            views: {
                'content@app': lazyLoadProvider.create(views.cessaoHub)
            },
            data: {
                title: 'Cessão Hub',
                access: { requiredPermissions: ['RemessaFundo', 'backoffice'] },
                breadcrumbs: ['BOS', 'Cessão Hub']
            }
        })
});